const SectionTitle = ({ title, coloredTitle, id }) => {
  return (
    <div className="text-center mb-16" id={id}>
      <h2 className="text-3xl md:text-4xl font-bold mb-4">
        {title} <span className="gradient-text">{coloredTitle}</span>
      </h2>
      <div className="w-20 h-1 bg-gradient-to-r from-blue-500 to-purple-600 mx-auto"></div>
    </div>
  );
};

export default SectionTitle;
